import { createAction, props } from '@ngrx/store';
import { UploadScreenTaxInfo } from 'src/app/pages/tax-validation/model/tax-validation';
export const loadFileTaxInformation = createAction('[File] uploadFilesTaxInfo', props<{ uploadFileTaxInfo: UploadScreenTaxInfo }>());
export const resetFileTaxInformation = createAction('[File] resetFilesTaxInfo status inital');


